import { createFilterStore } from './filterFactory';

export default createFilterStore < IInvoiceFilterParams >('invoiceFilter', {
  invoiceStatuses: [1, 2, 3, 7, 9],
  searchMonths: [],
});
